/**
 * =============================================================================
 * ListPageContent — Container da tabela/lista principal.
 *
 * Dois modos visuais:
 *   - Padrão (com respiro): aplica `flex-1 overflow-hidden px-4 pt-3`. Usado
 *     pelas listagens com tabela "encartada" como Cobranças/Financeiro,
 *     ReferralPayouts e ReferralCommissions (variante atual).
 *   - `fullBleed`: aplica apenas `flex-1 overflow-auto`, sem padding lateral.
 *     Usado pelas listagens densas que coloriem nas bordas, espelhando o
 *     padrão da página "Todos Negócios" (`CrmDeals`).
 *
 * @version 1.1.0
 * RELEASE:
 *   2026-04-25 v1.0.0 - Criação do helper de conteúdo padronizado.
 *   2026-04-25 v1.1.0 - Adicionada prop `fullBleed` para suportar paridade
 *                       visual com CrmDeals (tabela colada nas bordas).
 * =============================================================================
 */
import React from 'react';
import { cn } from '@/lib/utils';

interface ListPageContentProps {
  children: React.ReactNode;
  /**
   * Quando `true`, remove o padding/espaçamento lateral interno
   * (`px-4 pt-3`) e troca `overflow-hidden` por `overflow-auto`,
   * fazendo a tabela ocupar 100% da largura disponível (estilo CrmDeals).
   */
  fullBleed?: boolean;
  className?: string;
}

export function ListPageContent({
  children,
  fullBleed = false,
  className,
}: ListPageContentProps) {
  return (
    <div
      className={cn(
        fullBleed
          ? 'flex-1 overflow-auto'
          : 'flex-1 overflow-hidden px-4 pt-3',
        className,
      )}
    >
      {children}
    </div>
  );
}
